import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { Subscription } from './types';

type Variables = { id: number };
type Response = Subscription;

export const useSubscription = createQuery<Response, Variables, AxiosError>({
  queryKey: ['subscriptions/id'],
  fetcher: ({ id }) => {
    return client.get(`v2/subscriptions/${id}`).then((response) => {
      return response.data.data;
    });
  },
});
